import { DI } from 'aurelia';

export const IAppService = DI.createInterface<IAppService>('IAppService', (x) =>
    x.singleton(AppService)
);
export interface IAppService extends AppService {}

export class AppService {
    __scheme: any = {};
    __questions: any = [];
    __premiumModel: any = {};
    __policyModel: any = {};
    __paymentModel: any = {};
    __cachedValues: any = {};
    premiumIsValid = false;
    isAutoRateValid = true;
    autoRateErrors: any[] = [];
    sessionId;
    summaryQuestions = new Map();

    get scheme(): any {
        return this.__scheme;
    }

    storeScheme(scheme: string): void {
        this.__scheme = scheme;
    }

    get questions(): any[] {
        return this.__questions;
    }

    storeQuestions(questions: any[]): void {
        this.__questions = questions;
    }

    get premiumModel(): any {
        return this.__premiumModel;
    }

    storePremiumModel(premiumModel): void {
        this.__premiumModel = premiumModel;
    }

    get policyModel(): any {
        return this.__policyModel;
    }

    storePolicyModel(policyModel: any): void {
        this.__policyModel = policyModel;
        this.__policyModel.enablePremiumFunder =
            parseFloat(policyModel.invoiceAmount) < 15000;
    }

    get isFunderEnabled(): string {
        return this.__policyModel.enablePremiumFunder;
    }

    get paymentModel(): any {
        return this.__paymentModel;
    }

    storePaymentModel(paymentModel): void {
        this.__paymentModel = paymentModel;
    }

    get cachedValue(): any {
        return this.__cachedValues;
    }

    storeCachedValue(key, val): void {
        this.__cachedValues[key] = val;
    }
}
